import * as settings from "../../constants/settings";

/**
 * @class ColorDifferenceData
 */
export default class ColorDifferenceData {
    /**
     * @param {Object}  cieLab1976
     * @param {Object}  cieLab2000
     * @param {Object}  cmc
     * @param {Number}  metamerism
     */
    constructor(cieLab1976, cieLab2000, cmc, metamerism) {
        this._cieLab1976 = cieLab1976;
        this._cieLab2000 = cieLab2000;
        this._cmc = cmc;
        this._metamerism = metamerism;
    }

    getColorDifferenceByType = (type) => {
        switch (type) {
            case settings.CIE_LAB_1976:
                return this._cieLab1976;
            case settings.CIE_LAB_2000:
                return this._cieLab2000;
            case settings.CMC:
                return this._cmc;
            default:
                return this._cieLab2000;
        }
    };

    qualityControl = (type, metamerism, deltaE, deltaL, deltaA, deltaB) => {
        if (Math.abs(this._metamerism) > metamerism) {
            return false;
        }

        let colorDifference = this.getColorDifferenceByType(type);

        if (
            Math.abs(colorDifference.de) > deltaE ||
            Math.abs(colorDifference.dl) > deltaL ||
            Math.abs(colorDifference.da) > deltaA ||
            Math.abs(colorDifference.db) > deltaB
        ) {
            return false;
        }

        return true;
    };
}
